import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentUrlService } from '@shared/services/environment-url';
import { FSInterceptor } from '@services/fs-interceptor';
import { TabOpenService } from '@services/tab-open.service';
import { ContentDynamicLoader } from '@services/tab-content-loader.service';
import { LoginComponent } from '@components/login/login.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppConfig } from '@appconfig';
import { AuthService } from '@services/auth.service';
import { RouteGuardService } from '@services/route-guard.service';
import { CommonMethods } from '@services/common.method'; /* will be abolished eventually*/
import { CommonService } from '@shared/services/common';
import { TimeZoneConverter } from '@shared/pipes/timezone-converter';
import { LoginRouteGuardService } from '@services/login-route-guard.service';
import { ToastrModule } from 'ngx-toastr';
import { LoadingMarginPointComponent } from '@components/loader-mp/loader-mp.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DataSharing } from '@fs/services/data-sharing';
import { StatesService } from '@shared/services/states';
import { MenuModule } from '@progress/kendo-angular-menu';
import { CommonloaderModule } from '@commonloadermodule';
import { QbExtractorComponent } from './components/qb-extractor/qb-extractor.component';

@NgModule({
  declarations: [    
    AppComponent,
    LoginComponent,
    LoadingMarginPointComponent,
    QbExtractorComponent
  ],
  imports: [
    CommonloaderModule,BrowserModule, AppRoutingModule, InputsModule, MatProgressSpinnerModule, BrowserAnimationsModule,
    HttpClientModule, ReactiveFormsModule,
    FormsModule, ToastrModule.forRoot({
      timeOut: 5000,
      preventDuplicates: true,
      enableHtml:true,
      iconClasses: {
        warning: 'toast-warning toast-warning-customicon',
        error: 'toast-error toast-error-customicon'
      }
    }), MenuModule
  ],
  providers: [EnvironmentUrlService, TabOpenService, ContentDynamicLoader, RouteGuardService, LoginRouteGuardService, CommonMethods, CommonService,
      AppConfig, AuthService, TimeZoneConverter, DataSharing, {
      provide: HTTP_INTERCEPTORS,
      useClass: FSInterceptor,
      multi: true
    },StatesService],
  bootstrap: [AppComponent]
})
export class AppModule { }
